module.exports = __webpack_public_path__ + "static/media/arrow-right-circle-thin.bad2c047.svg";